import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getRuleDetail } from "../common/services";

export function mgmRuleLoader() {
  return defer({
    coreData: resolveLoaderResult(getRuleDetail()),
  });
}
